import { type InjectionKey } from 'vue'

/**
 * Primitive key for child components to
 * recognize they are in a modal
 */
export const PmModalPureKey = Symbol('PmModalPureKey') as InjectionKey<true>
